

















import { Component, Mixins } from "vue-property-decorator";
import { RectangleDragHandles } from "../../../../../../base/components/dragging";
import { BoxLineDrawer } from "../../../../../../base/components/drawing/drawers";
import { TexturedShapeObjectDrawerBase } from "./base";

@Component({
  components: {
    BoxLineDrawer,
    RectangleDragHandles,
  },
})
export default class BoxLineObjectDrawer extends Mixins(TexturedShapeObjectDrawerBase) {}
